/* VE SAV product page conversion helpers (loaded from snippets/ve-sav-help.liquid on product pages)
   1. No size pre-selected: until each option (Size, Length, ...) has been picked, the options look
      unselected and Add to bag reads "Select size"; pressing it brings the picker into view instead
      of adding a size the shopper never chose. Arriving with ?variant= in the URL counts as chosen.
   2. "Size guide" / "Size chart" link kept first in the stacked links at the end of the product
      info: Size guide, Shipping & returns, Need help? (built by ve-sav-ui.js). This also brings in a
      Size guide made as a pop-up block (the belt), so every product page has the same order.
   3. Phones: a slim bar always fixed to the bottom with name, price and Add to bag. It is the one
      place for them on phones: the in-page button, and the name and price under the gallery, are
      hidden there (CSS in ve-sav-help.liquid, only once this bar is showing).
   The theme (product-info.js) re-renders the picker and button on every option change, so all state
   lives here and is re-applied after each re-render. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    function picker() { return info.querySelector('variant-selects'); }
    function mainButton() { return info.querySelector('product-form button[name="add"]'); }
    function buttonLabel(btn) { return btn ? (btn.querySelector('span') || btn) : null; }

    function optionGroups() {
      var p = picker();
      if (!p) return [];
      return Array.prototype.slice.call(p.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown'));
    }

    function groupName(group) {
      var label = group.querySelector('legend, label.form__label');
      if (!label) return '';
      return (label.childNodes[0] ? label.childNodes[0].textContent : label.textContent).trim().replace(/:$/, '');
    }

    /* ---------- 1. Nothing pre-selected ---------- */
    var chosen = {};
    var requireChoice = !!picker() && !/[?&]variant=/.test(window.location.search);
    var addText = (buttonLabel(mainButton()) || {}).textContent;
    addText = addText ? addText.trim() : 'Add to bag';

    function missingGroups() {
      if (!requireChoice) return [];
      return optionGroups().filter(function (g) { return !chosen[groupName(g)]; });
    }

    function promptText() {
      var missing = missingGroups();
      if (!missing.length) return null;
      // Friendly wording for the button: "[SIZE]" -> "size", "Denominations" -> "amount"
      var name = groupName(missing[0]).replace(/[\[\]]/g, '').trim().toLowerCase();
      if (/denomination|amount|value/.test(name)) name = 'amount';
      return 'Select ' + name;
    }

    var applying = false;
    function apply() {
      if (applying) return;
      applying = true;
      optionGroups().forEach(function (g) {
        g.classList.toggle('vs-unchosen', requireChoice && !chosen[groupName(g)]);
      });

      var btn = mainButton();
      var label = buttonLabel(btn);
      var prompt = promptText();
      if (btn && label) {
        if (prompt) {
          if (label.textContent.trim() !== prompt) label.textContent = prompt;
          btn.classList.add('vs-needs-choice');
        } else if (btn.classList.contains('vs-needs-choice')) {
          btn.classList.remove('vs-needs-choice');
          if (!btn.disabled && label.textContent.trim() !== addText) label.textContent = addText;
        }
      }
      placeSizeGuide();
      syncSticky();
      applying = false;
    }

    function markChosen(target) {
      var group = target.closest('fieldset.product-form__input, .product-form__input--dropdown');
      if (!group || !picker() || !picker().contains(group)) return;
      chosen[groupName(group)] = true;
      apply();
    }

    // Clicking an already-checked size fires no change event, so listen to clicks too
    document.addEventListener('click', function (e) {
      if (e.target.matches && e.target.matches('variant-selects input[type="radio"]')) markChosen(e.target);
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('variant-selects select, variant-selects input')) markChosen(e.target);
    });

    // Block Add to bag until every option is picked; bring the first missing one into view
    function showMissing() {
      var missing = missingGroups();
      if (!missing.length) return false;
      var group = missing[0];
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      group.classList.remove('vs-attention');
      void group.offsetWidth;
      group.classList.add('vs-attention');
      return true;
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.closest || !form.closest('product-form') || !info.contains(form)) return;
      if (showMissing()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    /* ---------- 2. Size guide first in the bottom links ---------- */
    var sizeGuide = null;
    function findSizeGuide() {
      if (sizeGuide) return sizeGuide;
      var candidates = info.querySelectorAll('.vs-help-open, .product-popup-modal__opener');
      for (var i = 0; i < candidates.length; i++) {
        if (/size\s*(guide|chart)/i.test(candidates[i].textContent)) {
          sizeGuide = candidates[i];
          return sizeGuide;
        }
      }
      return null;
    }

    //   ... description / Size guide / Shipping & returns / Need help?
    function placeSizeGuide() {
      var row = info.querySelector('.vs-help-trigger');
      var link = findSizeGuide();
      if (!row || !link) return;
      link.classList.add('vs-size-guide-link');
      if (row.firstElementChild !== link) row.insertBefore(link, row.firstElementChild);
    }

    /* ---------- 3. Sticky name, price and Add to bag on phones ---------- */
    var mobile = window.matchMedia('(max-width: 749px)');
    var bar = null;
    var barButton = null;
    var barPrice = null;
    var mainVisible = true;

    function priceText() {
      var el = info.querySelector('.price .price-item--last, .price .price-item--sale, .price .price-item--regular');
      return el ? el.textContent.trim() : '';
    }

    function buildSticky() {
      var main = mainButton();
      if (!main || bar) return;
      var title = info.querySelector('.product__title h1') || info.querySelector('.product__title');

      bar = document.createElement('div');
      bar.className = 'vs-sticky-atc';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML =
        '<div class="vs-sticky-atc__text"><span class="vs-sticky-atc__title"></span>' +
        '<span class="vs-sticky-atc__price"></span></div>' +
        '<button type="button" class="vs-sticky-atc__button" tabindex="-1"></button>';
      bar.querySelector('.vs-sticky-atc__title').textContent = title ? title.textContent.trim() : '';
      barPrice = bar.querySelector('.vs-sticky-atc__price');
      barButton = bar.querySelector('.vs-sticky-atc__button');
      barButton.className = main.className.replace('button--full-width', '') + ' vs-sticky-atc__button';
      document.body.appendChild(bar);

      barButton.addEventListener('click', function () {
        if (showMissing()) return;
        var btn = mainButton();
        if (btn && !btn.disabled) btn.click();
      });

      // Visible = any part of the main Add to bag form is on screen
      function measure() {
        var form = info.querySelector('product-form');
        if (!form) return;
        var r = form.getBoundingClientRect();
        var visible = r.bottom > 0 && r.top < window.innerHeight;
        if (visible !== mainVisible) {
          mainVisible = visible;
          syncSticky();
        }
      }
      window.addEventListener('scroll', measure, { passive: true });
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      // Images loading in above the button push it down without any scroll, so re-check on layout changes
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(document.body);
      mobile.addEventListener('change', function () { measure(); syncSticky(); });
      measure();
    }

    function syncSticky() {
      if (!bar) return;
      var main = mainButton();
      var show = mobile.matches && !!main;
      bar.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('vs-has-sticky-atc', show);
      if (!main) return;
      var text = (buttonLabel(main).textContent || '').trim();
      if (barButton.textContent !== text) barButton.textContent = text;
      var disabled = main.disabled && !main.classList.contains('vs-needs-choice');
      barButton.disabled = disabled;
      var price = priceText();
      if (barPrice.textContent !== price) barPrice.textContent = price;
    }

    /* ---------- Keep everything in place after the theme re-renders ---------- */
    new MutationObserver(function () { apply(); }).observe(info, { childList: true, subtree: true, characterData: true });

    buildSticky();
    apply();
  });
})();
